// rel="noopener" kept as in the design (noreferrer would hide the referrer from stores/WhatsApp)
/* eslint-disable react/jsx-no-target-blank */
const SiteHeader = () => (
  <header className="kh-header" style={{ position: "sticky", top: "0", zIndex: "20", background: "rgba(11,18,64,0.94)", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
    <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "12px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "16px", flexWrap: "wrap" }}>
      <a href="#top" aria-label="خطوة — الصفحة الرئيسية" style={{ display: "flex", alignItems: "center" }}>
        <img width="204" height="130" src="/assets/img/logo-khotoua.webp" alt="لوغو خطوة" style={{ height: "48px", width: "auto", display: "block" }} />
      </a>
      <button type="button" className="kh-burger" aria-controls="kh-menu" aria-expanded="false" aria-label="القائمة">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true">
          <path d="M4 7h16M4 12h16M4 17h16" />
        </svg>
      </button>
      <nav id="kh-menu" className="kh-nav" aria-label="القائمة الرئيسية" style={{ display: "flex", gap: "22px", flexWrap: "wrap", fontWeight: "600", fontSize: "15px" }}>
        <a href="#about" style={{ color: "#E6E9FF", textDecoration: "none" }}>
          من نحن ؟
        </a>
        <a href="#contents" style={{ color: "#E6E9FF", textDecoration: "none" }}>
          المحتويات التعليمية
        </a>
        <a href="#features" style={{ color: "#E6E9FF", textDecoration: "none" }}>
          مميزات التطبيق
        </a>
        <a href="#schools" style={{ color: "#E6E9FF", textDecoration: "none" }}>
          للمدارس
        </a>
        <a href="#trust" style={{ color: "#E6E9FF", textDecoration: "none" }}>
          وثقوا بنا
        </a>
        <a href="#pricing" style={{ color: "#E6E9FF", textDecoration: "none" }}>
          الاشتراكات
        </a>
        <a href="#contact" style={{ color: "#E6E9FF", textDecoration: "none" }}>
          تواصل معنا
        </a>
      </nav>
      <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
        <a href="#lang" className="kh-lang" data-soon="النسختان الفرنسيّة والإنجليزيّة قيد الإعداد" style={{ display: "inline-flex", alignItems: "center", minHeight: "44px", padding: "0 12px", color: "#C9CEF5", textDecoration: "none", fontWeight: "600", fontSize: "14px" }}>
          AR · FR · EN
        </a>
        <button type="button" className="kh-parent" data-soon="فضاء الولي على الموقع قيد الإعداد" data-track="parent_space_click" style={{ display: "inline-flex", alignItems: "center", gap: "8px", minHeight: "44px", padding: "0 16px", borderRadius: "999px", border: "1.5px solid rgba(255,255,255,0.35)", background: "transparent", color: "#FFFFFF", fontWeight: "700", cursor: "pointer" }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="12" cy="8" r="4" />
            <path d="M4 21c1.500-4 4.500-6 8-6s6.500 2 8 6" />
          </svg>
          <span>
            فضاء الولي
          </span>
        </button>
        <a href="https://play.google.com/store/apps/details?id=com.DMNovaComany.Khotoua&pcampaignid=web_share" target="_blank" rel="noopener" style={{ display: "inline-flex", alignItems: "center", minHeight: "44px", padding: "0 20px", borderRadius: "999px", background: "#46D3BE", color: "#0B1240", fontWeight: "800", textDecoration: "none", boxShadow: "0 4px 0 rgba(0,0,0,0.25)" }}>
          حمّل التطبيق
        </a>
      </div>
    </div>
  </header>
);

export default SiteHeader;
